module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("广告管理新版")]), _vm._v(" "), _c('div', {
    staticClass: "ad-main-offset"
  }, [_vm._m(0), _vm._v(" "), _c('el-tabs', {
    staticClass: "ad-tabs",
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "strategy"
    }
  }, [_c('span', {
    staticClass: "ad-tab-label",
    class: {
      'is-active': _vm.activeTab === 'strategy'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("广告策略")]), _vm._v(" "), _c('div', {
    staticClass: "block-title"
  }, [_vm._v("默认策略")]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    staticClass: "ad-table",
    attrs: {
      "data": _vm.defaultTableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "策略名称",
      "min-width": "140",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "生效时间",
      "min-width": "220",
      "align": "center",
      "class-name": "cell-effect-time",
      "label-class-name": "cell-effect-time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "effect-time-cell"
        }, [(scope.row.effectTime === '永久') ? [_vm._v("永久")] : (scope.row.effectTimeStart && scope.row.effectTimeEnd) ? [_c('div', [_vm._v(_vm._s(scope.row.effectTimeStart))]), _vm._v(" "), _c('div', {
          staticClass: "effect-time-cell__end"
        }, [_vm._v("~" + _vm._s(scope.row.effectTimeEnd))])] : [_vm._v(_vm._s(scope.row.effectTime))]], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "crowd",
      "label": "适用人群",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "ad-status",
          class: _vm.statusRowClass(scope.row.status)
        }, [_c('i', {
          staticClass: "ad-status__dot"
        }), _vm._v(" "), _c('span', {
          staticClass: "ad-status__text"
        }, [_vm._v(_vm._s(_vm.strategyStatusText(scope.row)))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开屏",
      "min-width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "ad-slot-cell"
        }, [(_vm.isColdHotIntervalSlot(scope.row.openScreen)) ? [_c('div', {
          staticClass: "ad-slot-line"
        }, [_c('span', {
          staticClass: "ad-slot-tag"
        }, [_vm._v("冷启")]), _vm._v(_vm._s(scope.row.openScreen.cold))]), _vm._v(" "), _c('div', {
          staticClass: "ad-slot-line"
        }, [_c('span', {
          staticClass: "ad-slot-tag"
        }, [_vm._v("热启")]), _vm._v(_vm._s(scope.row.openScreen.hot))])] : _c('span', [_vm._v(_vm._s(scope.row.openScreen))])], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "首页-插屏",
      "min-width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "ad-slot-cell"
        }, [(_vm.isColdHotIntervalSlot(scope.row.homePop)) ? [_c('div', {
          staticClass: "ad-slot-line"
        }, [_c('span', {
          staticClass: "ad-slot-tag"
        }, [_vm._v("冷启")]), _vm._v(_vm._s(scope.row.homePop.cold))]), _vm._v(" "), _c('div', {
          staticClass: "ad-slot-line"
        }, [_c('span', {
          staticClass: "ad-slot-tag"
        }, [_vm._v("热启")]), _vm._v(_vm._s(scope.row.homePop.hot))])] : _c('span', [_vm._v(_vm._s(scope.row.homePop))])], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跑步结束-插屏",
      "min-width": "210",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "ad-slot-cell"
        }, [(_vm.isColdHotIntervalSlot(scope.row.runEndPop)) ? [_c('div', {
          staticClass: "ad-slot-line"
        }, [_c('span', {
          staticClass: "ad-slot-tag"
        }, [_vm._v("冷启")]), _vm._v(_vm._s(scope.row.runEndPop.cold))]), _vm._v(" "), _c('div', {
          staticClass: "ad-slot-line"
        }, [_c('span', {
          staticClass: "ad-slot-tag"
        }, [_vm._v("热启")]), _vm._v(_vm._s(scope.row.runEndPop.hot))])] : _c('span', [_vm._v(_vm._s(scope.row.runEndPop))])], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "homeFeed",
      "label": "首页-信息流",
      "min-width": "190",
      "align": "center",
      "class-name": "cell-nowrap",
      "label-class-name": "cell-nowrap"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "runEndFeed",
      "label": "跑步结束-信息流",
      "min-width": "200",
      "align": "center",
      "class-name": "cell-nowrap",
      "label-class-name": "cell-nowrap"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mineFeed",
      "label": "我的-信息流",
      "min-width": "170",
      "align": "center",
      "class-name": "cell-nowrap",
      "label-class-name": "cell-nowrap"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "floatingWindow",
      "label": "悬浮窗",
      "min-width": "120",
      "align": "center",
      "class-name": "cell-nowrap",
      "label-class-name": "cell-nowrap"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "effectiveSystemText",
      "label": "生效系统",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "scope",
      "label": "适用校区",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateAt",
      "label": "操作时间",
      "min-width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operator",
      "label": "操作人",
      "min-width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "240",
      "align": "center",
      "class-name": "column-op",
      "label-class-name": "column-op"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "op-btns"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleLinkCrowd(scope.row)
            }
          }
        }, [_vm._v("关联人群")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleLinkCampus(scope.row)
            }
          }
        }, [_vm._v("关联校区")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-row"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.defaultPagination.page,
      "page-size": _vm.defaultPagination.pageSize,
      "layout": "prev, pager, next, jumper, sizes, total",
      "total": _vm.defaultPagination.total
    },
    on: {
      "current-change": _vm.handleDefaultPageChange,
      "size-change": _vm.handleDefaultSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block-title custom-strategy-title"
  }, [_vm._v("自定义策略")]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "filter-row filter-row--custom-strategy"
  }, [_c('el-input', {
    staticClass: "filter-item",
    attrs: {
      "placeholder": "策略名称",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "filter-item",
    attrs: {
      "placeholder": "策略状态"
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "待生效",
      "value": "pending"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "生效中",
      "value": "active"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已过期",
      "value": "expired"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.queryCustomList
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn-add-custom-strategy",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.handleAddCustom
    }
  }, [_vm._v("+新增自定义策略")])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "ad-table",
    attrs: {
      "data": _vm.customTableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "策略名称",
      "min-width": "140",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "生效时间",
      "min-width": "220",
      "align": "center",
      "class-name": "cell-effect-time",
      "label-class-name": "cell-effect-time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "effect-time-cell"
        }, [(scope.row.effectTime === '永久') ? [_vm._v("永久")] : (scope.row.effectTimeStart && scope.row.effectTimeEnd) ? [_c('div', [_vm._v(_vm._s(scope.row.effectTimeStart))]), _vm._v(" "), _c('div', {
          staticClass: "effect-time-cell__end"
        }, [_vm._v("~" + _vm._s(scope.row.effectTimeEnd))])] : [_vm._v(_vm._s(scope.row.effectTime))]], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "crowd",
      "label": "适用人群",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "ad-status",
          class: _vm.statusRowClass(scope.row.status)
        }, [_c('i', {
          staticClass: "ad-status__dot"
        }), _vm._v(" "), _c('span', {
          staticClass: "ad-status__text"
        }, [_vm._v(_vm._s(_vm.strategyStatusText(scope.row)))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开屏",
      "min-width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "ad-slot-cell"
        }, [(_vm.isColdHotIntervalSlot(scope.row.openScreen)) ? [_c('div', {
          staticClass: "ad-slot-line"
        }, [_c('span', {
          staticClass: "ad-slot-tag"
        }, [_vm._v("冷启")]), _vm._v(_vm._s(scope.row.openScreen.cold))]), _vm._v(" "), _c('div', {
          staticClass: "ad-slot-line"
        }, [_c('span', {
          staticClass: "ad-slot-tag"
        }, [_vm._v("热启")]), _vm._v(_vm._s(scope.row.openScreen.hot))])] : _c('span', [_vm._v(_vm._s(scope.row.openScreen))])], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "首页-插屏",
      "min-width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "ad-slot-cell"
        }, [(_vm.isColdHotIntervalSlot(scope.row.homePop)) ? [_c('div', {
          staticClass: "ad-slot-line"
        }, [_c('span', {
          staticClass: "ad-slot-tag"
        }, [_vm._v("冷启")]), _vm._v(_vm._s(scope.row.homePop.cold))]), _vm._v(" "), _c('div', {
          staticClass: "ad-slot-line"
        }, [_c('span', {
          staticClass: "ad-slot-tag"
        }, [_vm._v("热启")]), _vm._v(_vm._s(scope.row.homePop.hot))])] : _c('span', [_vm._v(_vm._s(scope.row.homePop))])], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跑步结束-插屏",
      "min-width": "210",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "ad-slot-cell"
        }, [(_vm.isColdHotIntervalSlot(scope.row.runEndPop)) ? [_c('div', {
          staticClass: "ad-slot-line"
        }, [_c('span', {
          staticClass: "ad-slot-tag"
        }, [_vm._v("冷启")]), _vm._v(_vm._s(scope.row.runEndPop.cold))]), _vm._v(" "), _c('div', {
          staticClass: "ad-slot-line"
        }, [_c('span', {
          staticClass: "ad-slot-tag"
        }, [_vm._v("热启")]), _vm._v(_vm._s(scope.row.runEndPop.hot))])] : _c('span', [_vm._v(_vm._s(scope.row.runEndPop))])], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "homeFeed",
      "label": "首页-信息流",
      "min-width": "190",
      "align": "center",
      "class-name": "cell-nowrap",
      "label-class-name": "cell-nowrap"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "runEndFeed",
      "label": "跑步结束-信息流",
      "min-width": "200",
      "align": "center",
      "class-name": "cell-nowrap",
      "label-class-name": "cell-nowrap"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mineFeed",
      "label": "我的-信息流",
      "min-width": "170",
      "align": "center",
      "class-name": "cell-nowrap",
      "label-class-name": "cell-nowrap"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "floatingWindow",
      "label": "悬浮窗",
      "min-width": "120",
      "align": "center",
      "class-name": "cell-nowrap",
      "label-class-name": "cell-nowrap"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "effectiveSystemText",
      "label": "生效系统",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "scope",
      "label": "适用校区",
      "min-width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateAt",
      "label": "操作时间",
      "min-width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operator",
      "label": "操作人",
      "min-width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "240",
      "align": "center",
      "class-name": "column-op",
      "label-class-name": "column-op"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "op-btns op-btns--wrap"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleCopy(scope.row)
            }
          }
        }, [_vm._v("复制")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleLinkCrowd(scope.row)
            }
          }
        }, [_vm._v("关联人群")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleLinkCampus(scope.row)
            }
          }
        }, [_vm._v("关联校区")]), _vm._v(" "), _c('el-button', {
          staticClass: "danger-text",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.row)
            }
          }
        }, [_vm._v("删除")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-row"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pagination.page,
      "page-size": _vm.pagination.pageSize,
      "layout": "prev, pager, next, jumper, sizes, total",
      "total": _vm.pagination.total
    },
    on: {
      "current-change": _vm.handlePageChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "crowd"
    }
  }, [_c('span', {
    staticClass: "ad-tab-label",
    class: {
      'is-active': _vm.activeTab === 'crowd'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("人群圈定")]), _vm._v(" "), _c('div', {
    staticClass: "block-title"
  }, [_vm._v("默认人群")]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    ref: "defaultCrowdTableRef",
    staticClass: "ad-table ad-table--crowd",
    attrs: {
      "data": _vm.defaultCrowdRows
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "人群名称",
      "width": "120",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "人群说明",
      "min-width": "420",
      "align": "left",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "crowd-custom-row"
  }, [_c('div', {
    staticClass: "block-title crowd-custom-row__title"
  }, [_vm._v("自定义人群")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn-add-custom-strategy",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.handleAddCustomCrowd
    }
  }, [_vm._v("\n          + 新增自定义人群\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    ref: "customCrowdTableRef",
    staticClass: "ad-table ad-table--crowd",
    attrs: {
      "data": _vm.customCrowdTableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "人群名称",
      "min-width": "130",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "人群说明",
      "min-width": "180",
      "align": "left",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否学校任务跑用户",
      "min-width": "180",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.isSchoolRunUser ? "是" : "否") + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学期是否开始",
      "min-width": "120",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.semesterStartedLabel) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否有校园跑学期目标",
      "min-width": "200",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.hasCampusRunSemesterGoalLabel) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "semesterGoalProgress",
      "label": "校园跑学期目标进度",
      "min-width": "200",
      "align": "left",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跑步时段",
      "min-width": "220",
      "align": "left",
      "class-name": "column-running-time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "running-time-slot-cell"
        }, [(scope.row.runningTimeSlotParts.type === 'dash') ? [_vm._v("—")] : (scope.row.runningTimeSlotParts.type === 'raw') ? [_vm._v("\n                  " + _vm._s(scope.row.runningTimeSlotParts.text) + "\n                ")] : (scope.row.runningTimeSlotParts.type === 'pair') ? [(scope.row.runningTimeSlotParts.dayStr) ? _c('div', {
          staticClass: "running-time-slot-cell__days"
        }, [_vm._v("\n                    " + _vm._s(scope.row.runningTimeSlotParts.dayStr) + "\n                  ")]) : _vm._e(), _vm._v(" "), (scope.row.runningTimeSlotParts.timeStr) ? _c('div', {
          staticClass: "running-time-slot-cell__time"
        }, [_vm._v("\n                    " + _vm._s(scope.row.runningTimeSlotParts.timeStr) + "\n                  ")]) : _vm._e()] : _vm._e()], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "120",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "op-btns op-btns--left"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleCrowdEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          staticClass: "danger-text",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleCrowdDelete(scope.row)
            }
          }
        }, [_vm._v("删除")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-row"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.crowdPagination.page,
      "page-size": _vm.crowdPagination.pageSize,
      "layout": "prev, pager, next, jumper, sizes, total",
      "total": _vm.crowdPagination.total
    },
    on: {
      "current-change": _vm.handleCrowdPageChange,
      "size-change": _vm.handleCrowdSizeChange
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('ad-add-strategy-dialog', {
    attrs: {
      "visible": _vm.addDialogVisible,
      "edit-strategy-id": _vm.strategyDialogEditId,
      "duplicate-name-exclude": _vm.strategyDialogNameExclude,
      "strategy-prefill-dto": _vm.strategyPrefillDto,
      "existing-strategy-names": _vm.existingStrategyNames,
      "CampusZoneList": _vm.CampusZoneList
    },
    on: {
      "update:visible": function($event) {
        _vm.addDialogVisible = $event
      },
      "update:strategyPrefillDto": function($event) {
        _vm.strategyPrefillDto = $event
      },
      "update:strategy-prefill-dto": function($event) {
        _vm.strategyPrefillDto = $event
      },
      "saved": _vm.handleStrategyDialogSaved
    }
  }), _vm._v(" "), _c('link-crowd-dialog', {
    ref: "linkCrowdDialogRef",
    on: {
      "saved": _vm.handleLinkCrowdSaved
    }
  }), _vm._v(" "), _c('link-campus-dialog', {
    ref: "linkCampusDialogRef",
    attrs: {
      "campus-zone-list": _vm.CampusZoneList
    },
    on: {
      "saved": _vm.handleLinkCampusSaved
    }
  }), _vm._v(" "), _c('ad-add-crowd-dialog', {
    attrs: {
      "visible": _vm.addCrowdDialogVisible,
      "crowd-id": _vm.crowdDialogCrowdId,
      "initial-crowd-dto": _vm.crowdDialogInitialDto,
      "existing-crowd-names": _vm.existingCrowdNamesForDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.addCrowdDialogVisible = $event
      },
      "saved": _vm.handleAddCrowdSaved
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ad-tip"
  }, [_c('div', {
    staticClass: "ad-tip__title"
  }, [_vm._v("广告策略说明")]), _vm._v(" "), _c('div', {
    staticClass: "ad-tip__content"
  }, [_c('div', [_vm._v("当同一个广告位匹配到多条策略时，展示逻辑如下：")]), _vm._v(" "), _c('div', [_vm._v("1、若有1条策略命中【不展示】，则该广告位不展示广告；")]), _vm._v(" "), _c('div', [_vm._v("2、若没有策略命中【不展示】，则该广告位展示广告，且广告展示间隔分别按冷启/热启，取时间间隔最大的一条策略；")]), _vm._v(" "), _c('div', {
    staticClass: "ad-tip__example"
  }, [_vm._v("\n          例：用户王小明，属于 XX 校区的 XX 人群，同一条广告位若同时命中多条策略时，按上述规则确定是否展示及展示间隔。\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-87e5939e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/AdManagement/AdManagementNew.vue
// module id = 1098
// module chunks = 0